import React from 'react';
import { observer } from 'mobx-react-lite';
import img_checked from '@/assets/img/img_checked.png';
import img_uncheck from '@/assets/img/img_uncheck_v2.png';
import img_checked_notall from '@/assets/img/img_checked_notall.png';
import iconRadioNormal from '@/assets/img/radio_normal.png';
import iconRadioActive from '@/assets/img/radio_active.png';

const AppCheckBox = observer(props => {
  const { className = '', checked = false, isRadio, notAll = false, onClick } = props;

  return (
    <div
      className={`w-20px h-20px inline-block ${className}`}
      style={{
        background: `url(${checked ? (notAll ? img_checked_notall : (isRadio ? iconRadioActive : img_checked)) : (isRadio ? iconRadioNormal : img_uncheck)}) center center / contain no-repeat`,
      }}
      onClick={() => {
        onClick?.();
      }}
    />
  );
});
export default AppCheckBox;
